import { useRouter } from 'next/router';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design-components/base/eco-img';
import EcoSpace from 'eco-design-components/base/eco-space';
import { useState } from 'react';
import css from './index.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import { Swiper as SwiperType } from 'swiper/types';
import gtm from '@/utils/gtm';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';

interface ItemType {
    img: string[];
    text: string;
}

const J: React.FC = () => {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('rapidpro');
    const [active, setActive] = useState(0);
    const [swiper, setSwiper] = useState({
        realIndex: 0,
        slideTo: (_: number) => {},
        slidePrev: () => {},
        slideNext: () => {},
    } as SwiperType);

    let items: ItemType[] = [
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1749016422640/11_1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1749016444142/11_1_M.jpg'],
            text: t('J_item1'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1749016422408/11_2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1749016423352/11_2_M.jpg'],
            text: t('J_item2'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1749016422059/11_3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1749016422222/11_3_M.jpg'],
            text: t('J_item3'),
        },
        {
            img: [
                locale === 'ph'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1760689308098/11_4_ph.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1749016421864/11_4.jpg',
                locale === 'ph'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1760689307786/11_4_M_ph.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1749016422976/11_4_M.jpg',
            ],
            text: t('J_item4'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1749016422828/11_5.jpg', 'https://websiteoss.ecoflow.com/upload/image/1749016423192/11_5_M.jpg'],
            text: t('J_item5'),
        },
    ];

    if (locale === 'ph') {
        items.pop();
    }

    const handleSlideChange = () => {
        setActive(swiper?.realIndex);
    };

    const handleGTM = (num: number) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_detail_page',
            list_name: t('J_title'),
            button_name: num === 1 ? 'Left switch' : num === 2 ? 'Right switch' : 'none',
            __btn_id1: `rapid-pro-J .swiper-button-${num === 1 ? 'prev' : 'next'}`,
            __btn_id2: num == 2 ? '>' : '<',
            __btn_type: 'text',
        });
    };

    const { isPad } = useDeviceDetect();
    return (
        <div id="rapid-pro-J" className={`rapid-pro-J ${css.section} GtmModuleData-section`} data-section-id={`rapid-pro-J`} data-section-title={t('J_title')}>
            <EcoSpace />
            <div className="info">
                <p className="info-title">{t('J_title')}</p>
            </div>
            <Swiper
                modules={[Navigation]}
                className="swiper"
                spaceBetween={isPad ? 14 : 24}
                slidesPerView={'auto'}
                centeredSlides
                initialSlide={0}
                navigation={{
                    prevEl: `.rapid-pro-J .swiper-button-prev`,
                    nextEl: `.rapid-pro-J .swiper-button-next`,
                }}
                onSwiper={(swipwerIns: SwiperType) => setSwiper(swipwerIns)}
                loop
                onSlideChange={handleSlideChange}
            >
                {items?.map((item: ItemType, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1} swiper-item-${k === active ? 'active' : 'normal'}`} key={k}>
                        <EcoImg className="swiper-item-img" pc={item.img[0]} pad={item.img[0]} h5={item.img[1]} />
                        <p className="swiper-item-text">{item.text}</p>
                    </SwiperSlide>
                ))}
                <div className="swiper-button">
                    <button className={`swiper-button-prev GtmModuleData-btn-text swiper-button-btn`} onClick={() => handleGTM(1)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="45" viewBox="0 0 44 45" fill="none">
                            <path
                                d="M6.25977 0.719238L0.6875 6.60889V37.4536L6.25977 43.3442H37.0293L43.3125 37.4302V6.63232L37.0293 0.719238H6.25977Z"
                                stroke="white"
                                strokeWidth="1.375"
                            />
                            <mask id="path-2-inside-1_3127_21607_J1" fill="white">
                                <path d="M17.4167 33.0317L28.4167 22.0317L17.4167 11.0317" />
                            </mask>
                            <path
                                d="M18.389 34.004L17.4167 34.9763L15.4722 33.0317L16.4445 32.0595L18.389 34.004ZM28.4167 22.0317L29.389 21.0595C29.926 21.5964 29.926 22.467 29.389 23.004L28.4167 22.0317ZM16.4445 12.004L15.4722 11.0317L17.4167 9.08719L18.389 10.0595L16.4445 12.004ZM16.4445 32.0595L27.4445 21.0595L29.389 23.004L18.389 34.004L16.4445 32.0595ZM27.4445 23.004L16.4445 12.004L18.389 10.0595L29.389 21.0595L27.4445 23.004Z"
                                fill="white"
                                mask="url(#path-2-inside-1_3127_21607_J1)"
                            />
                        </svg>
                    </button>
                    <button className={`swiper-button-next GtmModuleData-btn-text swiper-button-btn`} onClick={() => handleGTM(2)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="45" viewBox="0 0 44 45" fill="none">
                            <path
                                d="M6.25977 0.719238L0.6875 6.60889V37.4536L6.25977 43.3442H37.0293L43.3125 37.4302V6.63232L37.0293 0.719238H6.25977Z"
                                stroke="white"
                                strokeWidth="1.375"
                            />
                            <mask id="path-2-inside-1_3127_21607_J2" fill="white">
                                <path d="M17.4167 33.0317L28.4167 22.0317L17.4167 11.0317" />
                            </mask>
                            <path
                                d="M18.389 34.004L17.4167 34.9763L15.4722 33.0317L16.4445 32.0595L18.389 34.004ZM28.4167 22.0317L29.389 21.0595C29.926 21.5964 29.926 22.467 29.389 23.004L28.4167 22.0317ZM16.4445 12.004L15.4722 11.0317L17.4167 9.08719L18.389 10.0595L16.4445 12.004ZM16.4445 32.0595L27.4445 21.0595L29.389 23.004L18.389 34.004L16.4445 32.0595ZM27.4445 23.004L16.4445 12.004L18.389 10.0595L29.389 21.0595L27.4445 23.004Z"
                                fill="white"
                                mask="url(#path-2-inside-1_3127_21607_J2)"
                            />
                        </svg>
                    </button>
                </div>
            </Swiper>
        </div>
    );
};

export default J;
